import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { catchError, map, retry } from 'rxjs/operators';

import { checkValidResponse, logError } from '@cigna/chcp/shared/util';
import { ClaimDetails, DetailRequest } from '@cigna/chcp/claims/shared/util';

@Injectable({ providedIn: 'root' })
export class ClaimsDetailsService {
  public SERVICE_CONSUMER_CODE = '1000';

  public claimsDetailsApi: string;

  constructor(
    private http: HttpClient,
    @Inject('secureApi') secureApi: string,
  ) {
    this.claimsDetailsApi = `${secureApi}/claims/v1`;
  }

  getClaimsDetails(payload: DetailRequest) {
    let params: HttpParams = new HttpParams()
      .set('consumerCode', this.SERVICE_CONSUMER_CODE)
      .set('claimReferenceNumber', payload.claimReferenceNumber)
      .set('claimCompositeKey', payload.claimCompositeKey)
      .set('tinNumbers', payload.tinNumbers);

    if (payload.memberSearch) {
      params = params.append('memberSearch', payload.memberSearch);
    }

    return this.http
      .get(`${this.claimsDetailsApi}/${payload.claimReferenceNumber}`, {
        params,
      })
      .pipe(
        retry(1),
        map(checkValidResponse),
        map((res: { claimDetailObject: ClaimDetails }) =>
          payload.groupNumber
            ? // with new 360 api we get groupNumber/ami/idCardExtensionCode along with summary response
              // so we can save a patient locator call later on if we patch it in here
              {
                ...res.claimDetailObject,
                claimInfoObject: {
                  ...res.claimDetailObject.claimInfoObject,
                  groupNumber: payload.groupNumber,
                  ami: payload.ami || res.claimDetailObject.claimInfoObject.ami,
                  idCardExtensionCode:
                    payload.idCardExtension ||
                    res.claimDetailObject.claimInfoObject.idCardExtensionCode,
                },
              }
            : res.claimDetailObject,
        ),
        catchError(logError),
      );
  }
}
